export class LicenseeSearch {
    licenseeid: number;
    month: number;
    year: number;
    statusid: number;
    denialReason?: number;
}

